import { Box, BoxProps, useBoolean } from "@chakra-ui/react";
import { useContextPreviewBlackboard } from "components/containers/inspectionDetail/context/PreviewBlackboard";
import { BlackboardData, BlackboardFrame } from "interfaces/models/blackboard";
import { InstanceProperty } from "interfaces/models/inspectionInstance";
import { PinDetail } from "interfaces/models/pin";
import { memo, useMemo } from "react";
import BlackboardFrames, { BlackboardFrameProps } from "./BlackboardFrames";
import Image from "components/Image";

interface Props extends BoxProps {
  layoutUrl: string | undefined;
  blackboardWidth: number | undefined;
  blackboardHeight: number | undefined;
  blackboardFrames: BlackboardFrame[] | undefined;
  pinDetail: PinDetail | undefined | null;
  blackboardData: BlackboardData | undefined;
  defaultFormValue?: Record<string, any>;
  defaultMapInstanceProperty?: Map<string, InstanceProperty>;
  isModeEditor?: boolean;
  blackBoardFramesProps?: Partial<BlackboardFrameProps>;
}

const Blackboard = (props: Props) => {
  const {
    blackboardFrames = [],
    layoutUrl,
    blackboardWidth,
    blackboardHeight,
    pinDetail,
    blackboardData,
    defaultFormValue,
    defaultMapInstanceProperty,
    isModeEditor,
    blackBoardFramesProps,
    ...boxProps
  } = props;

  const [isImageError, setIsImageError] = useBoolean();
  const [isLoadedBlackboardLayout, loadedBlackboardLayout] = useBoolean();
  const { blackboardFormat, isLoadingPropertyInstance } =
    useContextPreviewBlackboard();

  const zoomRatio = useMemo(() => {
    if (!blackboardFormat?.width || !blackboardWidth) {
      return 1;
    }

    return blackboardWidth / blackboardFormat.width;
  }, [blackboardFormat?.width, blackboardWidth]);

  if (!layoutUrl) {
    return <></>;
  }

  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      maxHeight="fit-content"
      {...boxProps}
    >
      {(isLoadingPropertyInstance || !isLoadedBlackboardLayout) && (
        <Box className="chakra-spinner" />
      )}
      <Image
        src={layoutUrl}
        onLoad={loadedBlackboardLayout.on}
        onError={setIsImageError.on}
        maxH="100%"
        objectFit="contain"
        w="100%"
        h="auto"
      />
      {isLoadedBlackboardLayout && !isImageError && (
        <BlackboardFrames
          frames={blackboardFrames}
          blackboardData={blackboardData}
          pinDetail={pinDetail}
          zoomRatio={zoomRatio}
          defaultFormValue={defaultFormValue}
          isModeEditor={isModeEditor}
          {...blackBoardFramesProps}
        />
      )}
    </Box>
  );
};

export default memo(Blackboard);
